import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch } from "antd";

import moment from "moment";

import { justificationsService } from "./../../redux/services";

import {
	UIDrawerForm,
	UIFormSection,
	UISwitchField,
} from "./../../components";

import { JUSTIFICATION_TYPES, JustificationsInfoBanner } from "./create";

class Show extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onClose: PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			item: {},
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			item: {},
		});

		justificationsService.show({ uuid })
			.then((response) => {
				this.setState({
					isLoading: false,
					item: response.data.data,
				});
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
	};

	onClose = () => {
		this.setState({
			item: {},
		});

		// Callback
		this.props.onClose();
	};

	render() {
		const { visible } = this.props;
		const { isLoading, item } = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-file-alt" />}
				title="Visualizar justificativa"
				subtitle="Consulte as informações da justificativa.">
				<Form layout="vertical">
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais"
						description="Nome e efeito da justificativa no ponto.">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Nome">
									{item.nome ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Tipo">
									{JUSTIFICATION_TYPES[item.acao] ?? "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Status">
									<UISwitchField
										bordered
										title="Ativo"
										description={item.ativo ? "Justificativa ativa e disponível para seleção ao ajustar o ponto." : "Justificativa inativa e fora da seleção ao ajustar o ponto."}>
										<Switch disabled checked={!!item.ativo} />
									</UISwitchField>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Criação">
									{item.created_at ? moment(item.created_at).calendar() : "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Última atualização">
									{item.updated_at ? moment(item.updated_at).calendar() : "-"}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
					<JustificationsInfoBanner />
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
